<template>
  <v-main>
    <v-container @contextmenu.prevent="()=>{}">
      <div class="edit_test">
        <!-- only show if submit button has not been clicked -->
        <div v-if="!testSubmitted">
          <TestDescription :test="test" v-if="!isLoading && test" />
          <!-- only show if test not attempted (returned from the server, checked when retrieving questions) -->
          <div v-if="!testAlreadyGiven">
            <!-- if current time is after start time and before end time then display this -->
            <div v-if="isOngoing">
              <div v-for="question in questions" :key="question.id">
                <QuestionCard :question="question" />
              </div>
            </div>
            <!-- test hasn't been started yet -->
            <div v-else-if="isUpcoming" class="text-center mt-4">
              <i class="fas fa-3x fa-hourglass-half"></i>
              <h2>Test not started yet. Please come back later.</h2>
            </div>
            <!-- if test is expired -->
            <div v-else class="text-center mt-4">
              <i class="fas fa-3x fa-history"></i>
              <h2>Test has already finished.</h2>
            </div>
          </div>
          <!-- displays this, if test already attempted -->
          <div v-else class="text-center mt-4">
            <div v-if="test.showResult">
              <i class="fas fa-3x fa-check"></i>
              <h2>Results are out. Check statistics.</h2>
            </div>
            <div v-else>
              <i class="fas fa-3x fa-user-check"></i>
              <h2>Test already attempted! Wait for the results to be out.</h2>
            </div>
          </div>
          <div v-if="isOngoing && !testAlreadyGiven">
            <v-btn
              :disabled="isLoading"
              @click="dialogs.submitConfirmationDialog = true"
              width="100%"
              color="primary"
              class="mt-4"
              large
            >
              Submit
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <h3 class="text-center mb-16 mt-2">Do not refresh the page after clicking on Submit</h3>
          </div>
        </div>
      </div>
    </v-container>
    <ConfirmationDialog
      :visible="dialogs.submitConfirmationDialog"
      title="Are you sure you want to submit the test?"
      subtitle="क्या आप वाकई परीक्षण सबमिट करना चाहते हैं?"
      description="You will not be able to make any changes after clicking 'Agree'."
      successText="Agree"
      failureText="Cancel"
      @successCallback="submitTest"
      @failureCallback="dialogs.submitConfirmationDialog = false"
    />
    <ConfirmationDialog
      :visible="dialogs.emptyFieldsWarningDialog"
      title="You haven't selected a few answers!"
      description="You can submit the test but you will lose marks for not attempting all questions"
      successText="Proceed Anyway"
      failureText="Cancel"
      @successCallback="proceedWithoutAnswering"
      @failureCallback="dialogs.emptyFieldsWarningDialog = false"
    />
    <ConfirmationDialog
      :visible="dialogs.successfullySubmittedDialog"
      title="Test Successfully Submitted!"
      description="You have successfully submitted the test. The results will be out soon."
      successText="OK"
      @successCallback="$router.push('/')"
    />
    <v-footer v-if="isOngoing" fixed class="font-weight-medium">
      <v-col class="text-center" cols="12">
        <strong>
          <Timer v-if="test" :endTimer="test.end_datetime" />
        </strong>
      </v-col>
    </v-footer>
  </v-main>
</template>


<script>
import TestDescription from "../../components/tests/TestDescription.vue";
import QuestionCard from "../../components/tests/QuestionCard.vue";
import { mapGetters, mapActions } from "vuex";
import testsApi from "@api/tests/all_tests";
import Helper from "@utils/misc";
import ConfirmationDialog from "@components/widgets/ConfirmationDialog.vue";
import Timer from "@components/widgets/misc/Timer.vue";
import moment from "moment";

window.onbeforeunload = function(e) {
  console.log(e);
  return confirm("Confirm refresh");
};



export default {
  name: "GiveTest",
  props: ["tid"],
  data() {
    return {
      test: null,
      testAlreadyGiven: false,
      testSubmitted: false,
      proceedWithoutAnsweringAll: false,
      questions: [],
      dialogs: {
        submitConfirmationDialog: false,
        emptyFieldsWarningDialog: false,
        successfullySubmittedDialog: false
      },
      events: {
        functions: {}
      },
    };
  },

  components: {
    TestDescription,
    Timer,
    QuestionCard,
    ConfirmationDialog
  },
  computed: {
    ...mapGetters(["isLoading", "accessToken", "answers"]),
    isOngoing() {
      return (
        moment(new Date(this.test.start_datetime * 1000)).isBefore(
          moment(new Date())
        ) &&
        moment(new Date(this.test.end_datetime * 1000)).isAfter(
          moment(new Date())
        )
      );
    },
    // checks if this.test is upcoming
    isUpcoming() {
      return moment(new Date(this.test.start_datetime * 1000)).isAfter(
        moment(new Date())
      );
    },
    isExpired() {
      return moment(new Date(this.test.end_datetime * 1000 + 12000)).isBefore(
        moment(new Date())
      );
    }
  },
  methods: {
    ...mapActions(["setLoading", "saveAnswers"]),
    postLoadFunction() {
      var self = this;
      console.log("PostLoadFunction executed");
      this.events.functions.detectCheatingFunction = async function() {
        if(self.isOngoing && !self.testSubmitted && !self.testAlreadyGiven){
          console.log("Hey Cheater! You Got Caught!");
          await testsApi.sendCheatingNotification(
            self.accessToken,
            self.$route.params.tid
          );
        }
      };

      window.removeEventListener(
        "blur",
        this.events.functions.detectCheatingFunction
      );
      window.addEventListener(
        "blur",
        this.events.functions.detectCheatingFunction
      );



      let now = new Date();
      const mills = this.test.end_datetime * 1000 - now + 10000;

      this.events.autoSubmitTimeout = setTimeout(() => {
        this.proceedWithoutAnsweringAll = true;
        this.submitTest();
        window.removeEventListener(
          "blur",
          this.events.functions.detectCheatingFunction
        );
      }, mills);
    },

    // gets test details
    async getTestDetails() {
      this.setLoading(true);
      // gets test details
      let testFromServer = await testsApi.getTestDetails(
        this.accessToken,
        this.$route.params.tid
      );
      if (!Helper.handleErrors(testFromServer, this.handleErrors)) return;
      // display
      this.test = testFromServer;
      this.setLoading(false);
    },

    // gets test questions
    async getTestQuestions() {
      this.setLoading(true);
      // get test questions
      let testQuestionsFromServer = await testsApi.getTestQuestions(
        this.accessToken,
        this.$route.params.tid
      );
      // check for errors
      if (!Helper.handleErrors(testQuestionsFromServer, this.handleErrors))
        return;
      // display

      if (!testQuestionsFromServer) {
        this.testAlreadyGiven = true;
      }

      this.questions = testQuestionsFromServer;
      this.setLoading(false);
    },

    // does not warn if all options not selected
    proceedWithoutAnswering() {
      this.proceedWithoutAnsweringAll = true;
      this.submitTest();
    },

    // checks if all question options have been filled and sends a warning if not
    validateFields() {
      let notFilled = false;
      // iterate over allQuestion ids and check if exists in this.answers
      this.questions.map(q => {
        if (!Object.prototype.hasOwnProperty.call(this.answers, q.id)) {
          notFilled = true;
        }
      });
      if (notFilled && !this.proceedWithoutAnsweringAll) {
        this.dialogs.emptyFieldsWarningDialog = true;
        return false;
      }

      return true;
    },

    // sends the questions and selected answers to server
    async submitTest() {
      this.dialogs.submitConfirmationDialog = false;
      this.dialogs.emptyFieldsWarningDialog = false;
      // check if anything is left empty
      if (!this.validateFields()) return;
      // if yes, show dialog box
      this.setLoading(true);
      // show don't refresh dialog

      // send test details to server
      let testSubmitResponse = await testsApi.submitTest(
        this.accessToken,
        { answers: this.answers },
        this.test.id
      ); // get response in return
      if (!Helper.handleErrors(testSubmitResponse, this.handleErrors)) return; // handle errors

      //else display submitted dialog
      this.testSubmitted = true;
      this.dialogs.successfullySubmittedDialog = true;
      this.setLoading(false);
    },

    // handles API Errors
    handleErrors(err) {
      console.log(err);
      if(err.response.status == 405){
        this.$router.push('/restricted');
      }
         // if test not found
      if(err.response.status == 404){
        // this.testNotFound = true;
        this.$router.push('/notfound');
      }
    },


  },
  async created() {
    await this.getTestDetails();
    await this.getTestQuestions();

    if (this.isOngoing) this.postLoadFunction();
  },

  // clears timers and stuff
  beforeDestroy() {
    window.clearInterval(this.events.autoSubmitTimeout);
    window.removeEventListener(
      "blur",
      this.events.functions.detectCheatingFunction
    );

  }
};
</script>

<style scoped>
*{
  -webkit-user-select: none;
}
</style>
